import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import { CashbookTxnBankStmtLinkContainer } from '../../../../../../models/aggregates/erp/index';


@Injectable({
    providedIn: 'root'
})
export class CashbookTxnBankStmtLinkService extends BaseApiTemplateService<CashbookTxnBankStmtLinkContainer> {
    
    readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/cashbook-txn-bank-stmt-links'

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/cashbook-txn-bank-stmt-links';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/cashbook-txn-bank-stmt-links';
        this.httpClient = http;
    }
    
}

